import { useEffect, useState } from "react";
import { ServiceApi } from "../../services/index.service";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import dayjs from "dayjs";
import { checkForCorporateUser } from "../../utils";

const useShopWebsiteCustomization = () => {
  const [shopWebsiteConfig, setShopWebsiteConfig] = useState(null);
  const [shopUrl, setShopUrl] = useState(null);
  const [originalShopWebsiteConfig, setOriginalShopWebsiteConfig] =
    useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState("");
  const serviceapi = new ServiceApi();
  const [store, setStore] = useState(null);
  const {  storage,profile } = useSelector((state) => state);

  useEffect(() => {
    if(store?.intStoreID){
      fetchAllApis();
    }
  }, [store]);

  const fetchAllApis = async () => {
    setLoading(true);
    await fetchShopWebsiteConfig(store?.intStoreID);
    setLoading(false);
  };


  useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);
  const displaySnackBarMessages = (errorMessage, type) => {
    enqueueSnackbar(errorMessage, {
      anchorOrigin: { vertical: "top", horizontal: "right" },
      variant: type,
    });
  };
  const fetchShopWebsiteConfig = async (storeId) => {
    const req = {
      intStoreID: storeId,
    };
    const res = await serviceapi.getShopWebsiteCustomization(req);
    setShopUrl(res?.ShopURL)
    setShopWebsiteConfig(res?.data);
    setOriginalShopWebsiteConfig(res?.data);
  };

  const handleChange = (parent, name, value) => {
    setShopWebsiteConfig({
      ...shopWebsiteConfig,
      [parent]: {
        ...shopWebsiteConfig[parent],
        [name]: value,
      },
    });
  };

  const handleSave = async (config, child = "") => {
    let req={}
    if(child){
      req = {
        intStoreID: store?.intStoreID,
        Category: config,
        ...originalShopWebsiteConfig[config],[child]:parseInt(shopWebsiteConfig[config][child])
      };
      console.log(req)
      setLoadingButton(child)
    }else{
      req = {
        intStoreID: store?.intStoreID,
        Category: config,
        ...shopWebsiteConfig[config],
      };
      if(config==="Catering"){
        req = {
          ...req,
          dteDateUpdated: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
        };
      }else if(config==="JobApplication"){
        if(!shopWebsiteConfig[config]?.intRitasJob){
          displaySnackBarMessages("Please Select Job Application Process",'error')
          return
        }else if (shopWebsiteConfig[config]?.intRitasJob === 3 && !shopWebsiteConfig[config]?.vchthirdPartyURL){
          displaySnackBarMessages("Please enter Third Party Url",'error')
          return
        }
      }
      setLoadingButton(config)
    }
    const res = await serviceapi.getShopWebsiteCustomization(req);
    setLoadingButton("")
    if (res?.statusCode === 200) {
      setOriginalShopWebsiteConfig({
        ...originalShopWebsiteConfig,
        [config]: shopWebsiteConfig[config],
      });
      enqueueSnackbar(res?.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      enqueueSnackbar(res?.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };
  const handleRestore = (config, child = "") => {
    if(child){
      setShopWebsiteConfig({
        ...shopWebsiteConfig,
        [config]: {...shopWebsiteConfig[config],[child]:originalShopWebsiteConfig[config][child]},
      });
    }else if(config==="Catering"){
      setShopWebsiteConfig({
        ...shopWebsiteConfig,
        "Catering": {...originalShopWebsiteConfig[config],bitPickUp:1},
      });
    }else{
      setShopWebsiteConfig({
        ...shopWebsiteConfig,
        [config]: originalShopWebsiteConfig[config],
      });
    }
  };
  const isAdmin= !checkForCorporateUser(profile?.role) ? true : false

  return {
    shopWebsiteConfig,
    loading,
    handleChange,
    handleSave,
    handleRestore,
    store,
    loadingButton,
    shopUrl,
    isAdmin
  };
};

export default useShopWebsiteCustomization;
